import { render, staticRenderFns } from "./LoggedUser.vue?vue&type=template&id=94df05f6&scoped=true&"
import script from "./LoggedUser.vue?vue&type=script&lang=js&"
export * from "./LoggedUser.vue?vue&type=script&lang=js&"
import style0 from "./LoggedUser.vue?vue&type=style&index=0&id=94df05f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../Projects/register/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94df05f6",
  null
  
)

export default component.exports